import React from 'react';
import { Helmet } from 'react-helmet';

import Card from '@components/Card';
import SignOut from '@shared/SignOut';

import ApplyRules from '../Console/Main/ApplyRules';
import EnvironmentRuleDiff from '../Console/Main/EnvironmentRuleDiff';
import OverrideFiles from '../Console/Main/OverrideFiles';
import PreviewRuleDiff from '../Console/Main/PreviewRuleDiff';
import Section from './components/Section';
import PersonalInfo from './PersonalInfo';

export default function UserProfile() {
  return (
    <>
      <Helmet>
        <title>User Profile &middot; Enigma Screen UI</title>
      </Helmet>
      <Card title='User Profile' shadow>
        <PersonalInfo />
        <Section>
          <SignOut />
        </Section>
      </Card>
      <Card title='Preview rule changes' shadow>
        <PreviewRuleDiff />
      </Card>
      <Card title='Compare environment rules' shadow>
        <EnvironmentRuleDiff />
      </Card>
      <Card title='Apply rules' shadow>
        <ApplyRules />
      </Card>
      <Card title='Override rules file' shadow>
        <OverrideFiles />
      </Card>
    </>
  );
}
